/*
 *   File : profile.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : profile
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 10-12-2021
*/

/*import packages*/
import { useEffect, useState } from 'react';
import { Modal } from 'bootstrap'

/*import components*/
import { ProfileKyc } from '../../components/card/index';
import { EditUser } from '../../components/modal/index';

const Profile = (props) => {
	//eslint-disable-next-line
	const [editableData, setEditableData] = useState(null);
	const [sectionEditing, setSectionEditing] = useState(null);

	useEffect(() => {
		if (editableData !== null) {
			var myModal = new Modal(document.getElementById("editDetails"), {});
			myModal.show();
		}
	}, [editableData])

	/* --- func to open edit user detail modal ---*/
	const setData = (temp) => {
		setEditableData(temp);
	}

	return (
		<>
			<div className="col-lg-12 mb-3" >
				<ProfileKyc
					data={props.data}
					title="Profile overview"
					type={1}
					Cliked={(temp) =>{ setData(temp); setSectionEditing("Profile overview")}}
					edit={(props.data.overview?.signup_progress === "INVESTED" || props.data.overview?.signup_progress === "ACCOUNT_CREATED" || props.data.overview?.signup_progress === "NOMINEE_ADDED" || props.data.overview?.signup_progress === "PROOF_ADDED") ? true : false}
				/>
			</div>
			<div className="col-lg-12 mb-3" >
				<ProfileKyc
					data={props.data}
					title="KYC details"
					type={2}
					Cliked={(temp) =>{ setData(temp); setSectionEditing("KYC details")}}
					edit={(props.data.overview?.signup_progress === "INVESTED" || props.data.overview?.signup_progress === "ACCOUNT_CREATED" || props.data.overview?.signup_progress === "NOMINEE_ADDED" || props.data.overview?.signup_progress === "PROOF_ADDED") ? true : false}
					//eslint-disable-next-line
					verified={props.data.kyc.kyc_status == "VERIFIED" ? true : false}
				/>
			</div>
			<div className="col-lg-12 mb-3" >
				<ProfileKyc
					data={props.data}
					title="Nominee details"
					type={5}
					edit={(props.data.overview?.signup_progress === "INVESTED" || props.data.overview?.signup_progress === "ACCOUNT_CREATED" || props.data.overview?.signup_progress === "NOMINEE_ADDED" || props.data.overview?.signup_progress === "PROOF_ADDED") ? true : false}
					Cliked={(temp) =>{ setData(temp); setSectionEditing("Nominee details")}}
				//eslint-disable-next-line
				/>
			</div>
			<div className="col-lg-6 mb-3" >
				<ProfileKyc
					data={props.data}
					title="Bank details"
					type={3}
					Cliked={(temp) =>{ setData(temp); setSectionEditing("Bank details")}}
					verified={false}
				/>
			</div>
			<div className="col-lg-6 mb-3" >
				<ProfileKyc
					data={props.data}
					title="Autopay"
					type={4}
					Cliked={(temp) =>{ setData(temp); setSectionEditing("Autopay")}}
					verified={false}
				/>
			</div>
			{
				editableData !== null && <EditUser id="editDetails"
					data={editableData}
					section={sectionEditing}
					userId={props.userId}
					close={() =>{ setEditableData(null); setEditableData(null)}}
					editUserDetails={(data, nomineeAvailable) => {
						props.editUserDetails(data, nomineeAvailable);
						setEditableData(null);
						setSectionEditing(null);
					}} />
			}
		</>
	);
}

export default Profile;